<ng-container *ngIf="orderType.identifierNameOptions">
	<div class="d-flex flex-wrap justify-content-evenly">
		<div *ngFor="let id of orderType.identifierNameOptions">
			<div
				class="card m-2 display-2 p-button-secondary"
				[ngClass]="orderIdentifier === id ? 'kiosk-option-selected' : 'kiosk-option-unselected'"
				(click)="setOrderIdentifier(id)"
			>
				{{ id }}
			</div>
		</div>
	</div>
</ng-container>
